import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeListController.php
* @route '/api/funeral-home'
*/
const GetFuneralHomeListController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFuneralHomeListController.url(options),
    method: 'get',
})

GetFuneralHomeListController.definition = {
    methods: ["get","head"],
    url: '/api/funeral-home',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeListController.php
* @route '/api/funeral-home'
*/
GetFuneralHomeListController.url = (options?: RouteQueryOptions) => {
    return GetFuneralHomeListController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeListController.php
* @route '/api/funeral-home'
*/
GetFuneralHomeListController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetFuneralHomeListController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\FuneralHome\GetFuneralHomeListController::__invoke
* @see app/Http/Controllers/FuneralHome/GetFuneralHomeListController.php
* @route '/api/funeral-home'
*/
GetFuneralHomeListController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetFuneralHomeListController.url(options),
    method: 'head',
})

export default GetFuneralHomeListController